export enum CampaignChoice {
	List	= 1,
	Patient	= 2
}

export enum CampaignStatus {
	Pending	= 0,
	Sended	= 1,
	Failed	= 2
}